import styled from 'styled-components';

export const Card = styled.div`
  background-color: ${({ theme }) => theme.white};
  width: 360px;
  padding: 0px 16px;
  border-radius: 6px;
  box-shadow: 0 7px 15px 0 rgba(0, 0, 0, 0.1);
  display: ${({ show }) => show ? show : 'none'};
  flex-direction: column;
  position: absolute;
  top: 64px;
  right: 84px;
  z-index: 10000;
`

export const LastRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding: 16px;
`
